var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTracks = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.642 0.117188V2.24064H0V0.117188H12.642ZM12.642 4.31472V6.43818H0V4.31472H12.642ZM0 10.6357V8.56163H8.44444V10.6357H0ZM14.7654 0.117188H20V2.24064H16.8395V11.7221C16.8395 12.5781 16.535 13.3188 15.9259 13.9443C15.3169 14.5699 14.5761 14.8826 13.7037 14.8826C12.8313 14.8826 12.0823 14.5699 11.4568 13.9443C10.8313 13.3188 10.5185 12.5699 10.5185 11.6974C10.5185 10.825 10.8313 10.0843 11.4568 9.47521C12.0823 8.86616 12.823 8.56163 13.679 8.56163C14.0412 8.56163 14.4033 8.62748 14.7654 8.75916V0.117188Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTracks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tracks.8868342ad31f5c9f6d521f531a385a11.svg";